<div class="buttonbar" [formGroup]="form">
  <app-service-response [responseMessages]="responseMessages"></app-service-response>
  <sc-flex stretchContent>
    <button class="cancel-movement-btn" mat-flat-button [disabled]="!movingOrderCancable"
      (click)="cancelOngoingMovementOrder()">
      <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.transport-details.action.cancel-movement-order-line1"></sc-dictionary-label>
      <br />
      <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.transport-details.action.cancel-movement-order-line2"></sc-dictionary-label>
    </button>

    <sc-content-spacer grow></sc-content-spacer>

    @if (defaultCompletionOption?.type === 'NO_FURTHER_PROCESSING') {
      <sc-select-field labelDictionaryKey="tmc-yard.entity.moving-order.movementStrategy.label" [data]="strategySelectionItems"
      formControlName="movementStrategy"></sc-select-field>
      <sc-content-spacer></sc-content-spacer>
      <button class="forward-to-process-btn" mat-flat-button (click)="forwardToProcess()"
        [disabled]="!createMovementEnabled">
        <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.transport-details.action.create-movement-order-forward-to-process-line1"></sc-dictionary-label>
        <br />
        <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.transport-details.action.create-movement-order-forward-to-process-line2"></sc-dictionary-label>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button class="create-movement-btn" mat-flat-button [disabled]="!createMovementEnabled"
        (click)="completeNoFurtherProcessing()">
        <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.transport-details.action.complete-no-further-processing"></sc-dictionary-label>
      </button>
    }

    @if (defaultCompletionOption?.type === 'COMPLETE_ON_WAITING_AREA') {
      <button class="forward-to-process-btn" mat-flat-button (click)="forwardToProcess()"
        [disabled]="!createMovementEnabled">
        <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.transport-details.action.create-movement-order-forward-to-process-line1"></sc-dictionary-label>
        <br />
        <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.transport-details.action.create-movement-order-forward-to-process-line2"></sc-dictionary-label>
      </button>
      <sc-content-spacer></sc-content-spacer>
      <button class="create-movement-btn" mat-flat-button [disabled]="!createMovementEnabled"
        (click)="commpleteOnWaitingArea()">
        <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.transport-details.action.create-movement-order-waitingarea-line1"></sc-dictionary-label>
        <br />
        <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.transport-details.action.create-movement-order-waitingarea-line2"></sc-dictionary-label> {{targetName}}
      </button>
    }

    @if (defaultCompletionOption?.type === 'FORWARD_TO_NEXT_PROCESSING_STATION') {
      <button class="create-movement-btn" mat-flat-button [disabled]="!createMovementEnabled"
        (click)="forwardToNextProcessingStation()">
        <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.transport-details.action.create-movement-order-line1"></sc-dictionary-label>
        <br />
        <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.transport-details.action.create-movement-order-line2"></sc-dictionary-label> {{targetName}}
      </button>
    }

  </sc-flex>
</div>
